import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FuseMatchMediaService {
  activeMediaQuery: string;
  onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

  /**
   * Constructor
   *
   * @param {BreakpointObserver} breakpointObserver
   */
  constructor(
    private breakpointObserver: BreakpointObserver
  ) {
    // Set the defaults
    this.activeMediaQuery = '';

    // Initialize
    this._init();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Initialize
   *
   * @private
   */
  private _init(): void {
    // Define breakpoints to observe
    const breakpoints = {
      Handset: Breakpoints.Handset,
      Tablet: Breakpoints.Tablet,
      Web: Breakpoints.Web
    };

    // Set up a subscription for each breakpoint
    Object.keys(breakpoints).forEach(key => {
      this.breakpointObserver.observe(breakpoints[key])
        .pipe(
          map(result => result.matches ? key : '')
        )
        .subscribe((mediaQuery: string) => {
          if (this.activeMediaQuery !== mediaQuery) {
            this.activeMediaQuery = mediaQuery;
            this.onMediaChange.next(mediaQuery);
          }
        });
    });
  }
}
